var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPensionBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3335 22.6666H27.6668C22.6668 22.6666 19.3335 25.1666 19.3335 31V36.9333C19.3335 37.55 19.9668 37.9333 20.5168 37.6833C22.1502 36.9333 24.0335 36.65 26.0168 37C30.4002 37.7833 33.6168 41.85 33.5002 46.3C33.4835 47 33.3835 47.6833 33.2002 48.35C33.0668 48.8666 33.4835 49.35 34.0168 49.35H44.3335C49.3335 49.35 52.6668 46.85 52.6668 41.0166V31C52.6668 25.1666 49.3335 22.6666 44.3335 22.6666ZM36.0002 40.1666C33.7002 40.1666 31.8335 38.3 31.8335 36C31.8335 33.7 33.7002 31.8333 36.0002 31.8333C38.3002 31.8333 40.1668 33.7 40.1668 36C40.1668 38.3 38.3002 40.1666 36.0002 40.1666ZM48.0835 39.3333C48.0835 40.0166 47.5168 40.5833 46.8335 40.5833C46.1502 40.5833 45.5835 40.0166 45.5835 39.3333V32.6666C45.5835 31.9833 46.1502 31.4166 46.8335 31.4166C47.5168 31.4166 48.0835 31.9833 48.0835 32.6666V39.3333Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3332 39.3334C20.6498 39.3334 17.6665 42.3167 17.6665 46C17.6665 47.25 18.0165 48.4334 18.6332 49.4334C19.7832 51.3667 21.8998 52.6667 24.3332 52.6667C26.7665 52.6667 28.8832 51.3667 30.0332 49.4334C30.6498 48.4334 30.9998 47.25 30.9998 46C30.9998 42.3167 28.0165 39.3334 24.3332 39.3334ZM27.6165 45.45L24.0665 48.7334C23.8332 48.95 23.5165 49.0667 23.2165 49.0667C22.8998 49.0667 22.5832 48.95 22.3332 48.7L20.6832 47.05C20.1998 46.5667 20.1998 45.7667 20.6832 45.2834C21.1665 44.8 21.9665 44.8 22.4498 45.2834L23.2498 46.0834L25.9165 43.6167C26.4165 43.15 27.2165 43.1834 27.6832 43.6834C28.1498 44.1834 28.1165 44.9834 27.6165 45.45Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensionBw);
export default __webpack_public_path__ + "static/media/pension-bw.7de3a21065058574f48ed49dc9689272.svg";
export { ForwardRef as ReactComponent };